import request from '@/config/axios'

export interface ShareholderWithdrawVO {
  id?: number
  userId?: number
  userNickname?: string
  price?: number
  feePrice?: number
  type?: number
  userName?: string
  userAccount?: string
  bankName?: string
  bankAddress?: string
  qrCodeUrl?: string
  status?: number
  auditReason?: string
  auditTime?: string
  remark?: string
  payTransferId?: number
  transferChannelCode?: string
  transferErrorMsg?: string
  transferTime?: string
  createTime?: string
}

export const getShareholderWithdrawPage = async (params: any) => {
  return await request.get({ url: '/trade/shareholder/withdraw/page', params })
}

export const getShareholderWithdraw = async (id: number) => {
  return await request.get({ url: '/trade/shareholder/withdraw/get', params: { id } })
}

export const approveShareholderWithdraw = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/withdraw/approve', params: { id } })
}

export const rejectShareholderWithdraw = async (data: { id: number; auditReason?: string }) => {
  return await request.put({ url: '/trade/shareholder/withdraw/reject', data })
}

export const reTransferShareholderWithdraw = async (id: number) => {
  return await request.put({ url: '/trade/shareholder/withdraw/re-transfer', params: { id } })
}
